import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import EditGrid from '../ui/EditGrid/EditGrid';
import * as apiDashBoardService from './apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { GridColumns } from './GridColumns';
import { getUsers } from '../NewProcess/apiRequestService';
import PropTypes from 'prop-types';


export class UserNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridFunc: null,
      gridColumns: GridColumns,
      CRUDServices: {
        Create: apiDashBoardService.createUserNotification,
        Update: apiDashBoardService.updateUserNotification,
        Delete: apiDashBoardService.deleteUserNotificationById
      }
    };
  }
  refreshList() {
    apiDashBoardService.getUserNotifications()
      .then((response) => {
        const gridColumns = this.state.gridColumns;

        if (response.data && response.data.length > 0) {
          gridColumns
            .filter(item => item.field === "user")
            .forEach(item => {
              this.afterDataLoaded(item, response.data);
            });
        }

        this.gridFunc.setState({
          gridRows: response.data,
          gridColumns: gridColumns,
          columnVisibilityModel: { id: false, userId: false }
        });
      })
      .catch((exception) => {
        this.props.actions.setNotification(
          "Kullanıcı iletişim bilgileri getirilemedi daha sonra tekrar deneyin.",
          "error"
        );
        console.log("getUserNotifications exception: " + JSON.stringify(exception));
      });
  }
  componentDidMount() {
    getUsers()
      .then((response) => {
        this.setState(prevState => ({
          gridColumns: prevState.gridColumns.map(item =>
            item.field === "user" ? { ...item, dataList: response.data } : item
          )
        }), () => {
          this.refreshList();
        });
      })
      .catch((exception) => {
        this.props.actions.setNotification(
          "Kullanıcı bilgileri getirilemedi daha sonra tekrar deneyin.",
          "error"
        );
        console.log("getUsers exception: " + JSON.stringify(exception));

        this.refreshList();
      });
  }

  closeEditPage(ele) {
    this.refreshList();
  }

  afterDataLoaded(currentItem, processData) {
    let field = currentItem.field;
    let dataList = currentItem.dataList;
    let keyField = currentItem.keyField;
    let valueField = currentItem.valueField;

    processData.forEach(notification => {
      const user = dataList.find(user => user.id === notification.userId);
      if (user) {
        notification.user = user;
      }
    });

    for (const processItem of processData) {
      if (processItem[field] == null) continue;
      for (const element of dataList) {
        if (element[keyField] === processItem[field][keyField]) {
          processItem[field][valueField] = element[valueField];
        }
      }
    }

  }

  render() {
    const { CRUDServices } = this.state;

    return (
      <div>
        <div style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
          <BasicPageComponent>
            <ScreenContainer>
              <EditGrid
                ref={instance => {
                  this.gridFunc = instance;
                }}
                dialogTitle="Kullanıcı İletişim Tanımı"
                gridHeight={400}
                {...this.props}
                CRUD={CRUDServices}
                LoadData={(e) => this.closeEditPage(e)}
              />
            </ScreenContainer>
          </BasicPageComponent>
        </div>
      </div>
    );
  }
}

UserNotification.propTypes = {
  actions: PropTypes.shape({
    setNotification: PropTypes.func.isRequired
  }).isRequired
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  )
)(UserNotification);